<template>
  <div class="row">
    <div class="col-sm-2 sdbr">
      <Sidebar />
    </div>
    <div class="col-sm-10 ">
      <div class="row">
        <div class="col-sm-12 pt-1">
          <i class="fa fa-angle-double-left" @click="setPrevRoute"></i>
        </div>
        <div class="col-sm-12 h3 text-center">New Users</div>
        <div class="col-sm-12 text-right py-1">
          <Timeframe v-on:timeFrameEmit="dateChanged" :filter="filterObj" />
        </div>
      </div>
      <div class="row" v-if="newUserCnt">
        <div class="col-sm-12">
          {{ newUserCnt }} new users {{ getDayStr(filterObj.days) }}.
        </div>
      </div>
      <div
        class="row d-flex justify-content-end py-2"
        style="background-color: rgba(0, 123, 255, 0.5) ; border-top-left-radius: 0.63rem; border-top-right-radius: 0.63rem;"
      >
        <div class="col-lg-3 searchbar">
          <input
            class="mt-1 form-control"
            type="search"
            aria-label="Search through site content"
            placeholder="Search Users by name or email"
            v-model="search"
          />
        </div>
        <div class="offset-lg-7"></div>
        <div class="col-lg-2">
          <!-- <select
            class="form-control m-1"
            v-model="plan"
            @click="filterPlan(plan)"
          >
            <option value="all">All</option>
            <option value="obalx7">Free</option>
            <option value="hgdrvf">Pay as you go</option>
          </select> -->
        </div>
      </div>
      <div class="row border " 
      style="height: 60vh; overflow-y: auto ; 
      border-bottom-left-radius: 0.63rem; 
      border-bottom-right-radius: 0.63rem;">
        <table class="table table-list">
          <thead>
            <tr>
              <th scope="col">Name</th>
              <th scope="col">Plan</th>
              <th scolpe="col">Onboarding Date</th>
              <!-- <th scope="col">Category</th> -->
              <th scope="col">Last Active</th>
              <th scope="col">Total Calls</th>
            </tr>
          </thead>
          <tbody class="tab-data" id="tabData">
            <tr
              v-for="users in newUserFiltered"
              v-bind:key="users._id"
              class="ubuntu-medium"
            >
              <td
                class="cap"
                :class="[!users.user.aws_key ? inactive : '']"
                @click="navigate(users.user.aws_key.value)"
              >
                {{ users.user.name ? users.user.name : "NA" }}
                <div>{{ users.user.email }}</div>
                <div>
                  <small>{{
                    users.user.aws_key ? users.user.aws_key.value : ""
                  }}</small>
                </div>
              </td>
              <td>
                <p v-for="(plan, i) in getPlanNames(users.user)" :key="i">{{plan}}</p>
                <!-- {{ getPlanName()}}</td> -->
              <!-- <td>{{ getUserPlan(users.user.planId, users.lastActivity) }}</td> -->
              <td>{{ getDate(users.user.createdAt) }}</td>
              <!-- <td>
                {{
                  users.category === "No activity"
                    ? "-"
                    : caseConversion(users.category)
                }}
              </td> -->
              <td>
                {{
                  users.lastActivity
                    ? getFromNow(users.lastActivity)
                    : "No Activity"
                }}
              </td>
              <td>{{ users.total || 0 }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="row mt-1">
        <div class="col-sm-9 offset-sm-1 text-center" v-if="newUserCnt">
          <button
            class="btn btn-lg btn-link p-2 mr-2"
            @click="firstPage"
            :disabled="pageNumber === 1"
          >
            <i class="fas fa-angle-double-left"></i>
          </button>
          <button
            class="btn btn-lg btn-link p-2 mr-2"
            @click="prevPage"
            :disabled="pageNumber === 1"
          >
            <i class="fas fa-angle-left"></i>
          </button>
          <span>Page {{ pageNumber }} of {{ pageCount }}</span>
          <button
            class="btn btn-lg btn-link p-2 ml-2"
            @click="nextPage"
            :disabled="pageNumber === pageCount"
          >
            <i class="fas fa-angle-right"></i>
          </button>
          <button
            class="btn btn-lg btn-link p-2 mr-2"
            @click="lastPage"
            :disabled="pageNumber === pageCount"
          >
            <i class="fas fa-angle-double-right"></i>
          </button>
        </div>
        <!-- <div
          class="col-sm-2 btn btn-secondary mt-1"
          @click="generateReport(filterObj.from, filterObj.to, plan)"
        >
          <i class="fa fa-download" aria-hidden="true"></i>
          Download CSV
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import Sidebar from "./sidebar";
import Timeframe from "./Timeframe";
import moment from "moment";
import helpers from "../../mixins/helpers";
import downloadCsv from "download-csv";

export default {
  mounted() {
    this.filterObj = {
      custom:
        this.$route.query.custom && this.$route.query.custom == "true"
          ? true
          : false,
      days: this.$route.query.days ? this.$route.query.days : 1,
      from:
        this.$route.query.from ||
        moment().utc().startOf("day").format("YYYY-MM-DD HH:mm:ss"),
      to:
        this.$route.query.to ||
        moment().utc().endOf("day").format("YYYY-MM-DD HH:mm:ss"),
    };
    this.getApiUsage("all", this.filterObj.from, this.filterObj.to);
  },
  data() {
    return {
      pageNumber: 1,
      pageCount: 1,
      search: "",
      newUser: [],
      allUsers: [],
      allPlans: [],
      newUserCnt: "",
      startDt: "",
      endDt: "",
      filterObj: { custom: false, days: 1 },
      lastCall: "",
      day: this.$route.query.days,
      plan: "all",
      inactive: "avoid-clicks",
    };
  },
  computed: {
    newUserFiltered() {
      // if (this.newUser.length) {
      return this.newUser.filter((user) => {
        if (
          user.user.name.toLowerCase().includes(this.search.toLowerCase()) || 
          // user.user.aws_key.value.toLowerCase().includes(this.search.toLowerCase()) ||
          user.user.email.toLowerCase().includes(this.search.toLowerCase())
        )
          return user;
      });
      // }
    },
  },
  mixins: [helpers],
  components: {
    Sidebar,
    Timeframe,
  },
  methods: {
    getPlanNames(user) {
      console.log(user)
      let activePlans = this.allPlans.filter((plan) => {
        return user.planIds.indexOf(plan._id) !== -1 ? true : false
      })
      let planNames = activePlans.map((ele) => {
        let name = ele.plan_name
        name = name.split('_').join("  ")
        console.log()
        return name
      })

      return planNames
    },
    getApiUsage(plan, start, end) {
      // const apiUri = `http://localhost:5000/dashboard/user-stats?start=${start}&end=${end}&page=${this.pageNumber}&plan=${plan}`;
      const apiUri = `http://13.235.254.91:5000/dashboard/user-stats?start=${start}&end=${end}&page=${this.pageNumber}&plan=${plan}`;
      const options = {
        url: apiUri,
        method: "GET",
      };
      this.$http(options).then((result) => {
        this.allPlans = result.data.allPlan[0]
        // console.log(result, 'result is here, 2')
        this.newUser = result.data.nUsersPromise;
        this.newUserCnt = result.data.newUserCnt;
        if (!this.newUser.length) {
          this.resetPageParams();
        } else {
          this.pageCount = this.countOfPages(this.newUserCnt);
        }
      });
    },
    dateChanged(f) {
      this.filterObj.custom = f.custom;
      this.filterObj.days = f.num;
      this.filterObj.from = f.startDt;
      this.filterObj.to = f.endDt;
      this.$router.push({ path: "/nusers", query: this.filterObj });
    },
    nextPage() {
      this.pageNumber++;
      this.getApiUsage(this.plan, this.filterObj.from, this.filterObj.to);
    },
    prevPage() {
      this.pageNumber--;
      this.getApiUsage(this.plan, this.filterObj.from, this.filterObj.to);
    },
    firstPage() {
      this.pageNumber = 1;
      this.getApiUsage(this.plan, this.filterObj.from, this.filterObj.to);
    },
    lastPage() {
      this.pageNumber = this.pageCount;
      this.getApiUsage(this.plan, this.filterObj.from, this.filterObj.to);
    },
    resetPageParams() {
      this.pageNumber = 1;
      this.pageCount = 1;
    },
    setTimeFrame(num) {
      this.filterBy(num);
    },
    filterPlan(planId) {
      this.getApiUsage(planId, this.filterObj.from, this.filterObj.to);
    },
    countOfPages(newusercnt) {
      return Math.ceil(newusercnt / 20);
    },
    filterBy(d) {
      let num = d.num;
      this.startDt = d.startDt;
      this.endDt = d.endDt;
      this.day = d.day;
      this.getApiUsage(this.plan, this.startDt, this.endDt);
    },
    getUserPlan(planId, la) {
      if (planId === "obalx7") {
        return "Free";
      } else if (planId === "hgdrvf") {
        return "Pay as you go";
      } else if (la === "Verification Pending")
      {
        return "-"
      }
      else {
        return "Custom";
      }
    },
    getDayStr(n) {
      switch (n) {
        case "1":
          return "today";
          break;
        case "7":
          return "this week";
          break;
        case "30":
          return "this month";
          break;
        default:
          return "In the selected range";
      }
    },
    setPrevRoute() {
      this.$router.go(-1);
    },
    getDate(dt) {
      return moment(dt).format("DD-MMM-YYYY, hh:mm:A");
    },
    getFromNow(dt) {
      if (dt === "Verification Pending") return dt;
      return moment(dt).fromNow();
    },
    navigate(key) {
      this.$router.push({
        path: `/user/${key}/info`,
        query: {
          custom: true,
          days: this.$route.query.days,
          from: this.$route.query.from,
          to: this.$route.query.to,
          parent_route: "nusers",
        },
      });
    },
    generateReport(start, end, plan) {
      const apiUri = `http://13.235.254.91:5000/dashboard/newusers/csv?start=${start}&end=${end}&plan=${plan}`;
      // const apiUri = `http://localhost:3002/dashboard/newusers/csv?start=${start}&end=${end}&plan=${plan}`;
      const options = {
        url: apiUri,
        method: "GET",
      };
      this.$http(options).then(async (result) => {
        let allUsers = await result.data.allNewUsers;
        this.allUsers = await allUsers.map((elm) => {
          let reportObj = {
            name: elm.user.name,
            email: elm.user.email,
            key: elm.user.aws_key ? elm.user.aws_key.value : "",
            plan: this.getUserPlan(elm.user.planId, elm.lastActivity),
            category:
              elm.category === "No activity"
                ? "-"
                : this.caseConversion(elm.category),
            lastActive: elm.lastActivity
              ? this.getFromNow(elm.lastActivity)
              : "No Activity",
            total: elm.total || 0,
            onboarding: this.getDate(elm.user.createdAt),
          };
          return reportObj;
        });
        downloadCsv(this.allUsers);
      });
    },
  },
  watch: {
    $route() {
      this.filterObj = {
        custom:
          this.$route.query.custom && this.$route.query.custom == "true"
            ? true
            : false,
        days: this.$route.query.days ? this.$route.query.days : 1,
        from: this.$route.query.from || null,
        to: this.$route.query.to || null,
      };
      this.pageNumber = 1;
      this.getApiUsage(this.plan, this.filterObj.from, this.filterObj.to);
    },
  },
};
</script>

<style scoped>
.cap {
  text-transform: capitalize;
  cursor: pointer;
}
.avoid-clicks {
  pointer-events: none;
}
</style>